export const getRatingsLabel = (rating: string): string => {
    return rating.replace('&', 'Stars &');
};

const FACET_VALUE_COMMA_PLACEHOLDER = '__FACET_VALUE_COMMA__';

export const escapeFacetValueCommas = (value: string): string => {
    return value.replaceAll(',', FACET_VALUE_COMMA_PLACEHOLDER);
};

export const splitByCommaOutsideParentheses = (str: string): string[] => {
    if (str === undefined || str === null) {
        return [];
    }

    const values: string[] = [];
    let currentValue = '';
    let parenthesesDepth = 0;

    for (let index = 0; index < str.length; index += 1) {
        const currentChar = str[index];

        if (currentChar === '(') {
            parenthesesDepth += 1;
            currentValue += currentChar;
            continue;
        }

        if (currentChar === ')') {
            parenthesesDepth = Math.max(0, parenthesesDepth - 1);
            currentValue += currentChar;
            continue;
        }

        if (currentChar !== ',') {
            currentValue += currentChar;
            continue;
        }

        const previousChar = str[index - 1] ?? '';
        const nextChar = str[index + 1] ?? '';
        const isInsideParentheses = parenthesesDepth > 0;
        const isFollowedBySpace = nextChar === ' ';
        const isDecimalComma = /\d/.test(previousChar) && /\d/.test(nextChar);
        let isPriceRangeSeparator = false;
        if (isDecimalComma) {
            const valueBeforeComma = str.slice(0, index);
            if (/\d+\s+TO\s+\d+$/i.test(valueBeforeComma)) {
                const valueAfterComma = str.slice(index + 1);
                isPriceRangeSeparator = /^\d+\s+TO\s+\d+/i.test(
                    valueAfterComma,
                );
            }
        }

        if (
            isInsideParentheses ||
            isFollowedBySpace ||
            (isDecimalComma && !isPriceRangeSeparator)
        ) {
            currentValue += currentChar;
            continue;
        }

        values.push(
            currentValue.replaceAll(FACET_VALUE_COMMA_PLACEHOLDER, ','),
        );
        currentValue = '';
    }

    values.push(currentValue.replaceAll(FACET_VALUE_COMMA_PLACEHOLDER, ','));

    return values;
};
